import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ForWhomSection() {
  const yesList = ['Sos de las que quiere impresionar en cada reunión familiar', 'Te encanta la pastelería pero las recetas "difíciles" siempre te juegan en contra', 'Querés dominar el postre más pedido en fiestas y eventos de Argentina', 'Sos emprendedora y buscás un producto con alto margen para vender', 'Nunca hiciste una milhojas y querés empezar bien'];
  const noList = ['Buscás recetas genéricas que ya están en Google', 'No estás dispuesta a seguir el método paso a paso como se indica', 'Querés resultados sin práctica ni dedicación'];
  return <section className="bg-white py-12 md:py-16" data-id="element-103">
      <div className="max-w-6xl mx-auto px-4" data-id="element-104">
        <FadeIn data-id="element-105">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-brown text-center mb-16" data-id="element-106">
            ¿Para quién es el Método Milhojas Perfecta?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-107">
          {/* SÍ ES PARA VOS */}
          <FadeIn delay={0.1} direction="left" data-id="element-108">
            <div className="bg-brand-green/30 border border-green-200 rounded-2xl p-8 h-full shadow-sm" data-id="element-109">
              <h3 className="text-2xl font-bold text-green-800 mb-8 flex items-center" data-id="element-110">
                <span className="text-3xl mr-3" data-id="element-111">✅</span> SÍ ES PARA VOS SI...
              </h3>
              <ul className="space-y-6" data-id="element-112">
                {yesList.map((item, index) => <li key={index} className="flex items-start" data-id="element-113">
                    <span className="text-green-600 mr-3 mt-1 flex-shrink-0" data-id="element-114">
                      ✓
                    </span>
                    <span className="text-brand-brown text-lg" data-id="element-115">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NO ES PARA VOS */}
          <FadeIn delay={0.2} direction="right" data-id="element-116">
            <div className="bg-red-50 border border-red-100 rounded-2xl p-8 h-full shadow-sm" data-id="element-117">
              <h3 className="text-2xl font-bold text-red-800 mb-8 flex items-center" data-id="element-118">
                <span className="text-3xl mr-3" data-id="element-119">❌</span> NO ES PARA VOS SI...
              </h3>
              <ul className="space-y-6" data-id="element-120">
                {noList.map((item, index) => <li key={index} className="flex items-start" data-id="element-121">
                    <span className="text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-122">
                      ✗
                    </span>
                    <span className="text-brand-brown text-lg" data-id="element-123">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}